<template>
    <div class="editionpaybox" id="tac">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm" label-position="left">

        <div class="top">
            <div class="topcontent">
                <div class="topimg">
                    <img src="../../public/statics/img/logo.jpg" alt="" @click="jumpediton()">
                </div>
                <div class="topright">
                    <div class="topright1">
                        IDA云物流
                    </div>
                    <div class="topright2">
                        <div class="topright2s">
                            智慧物流
                        </div>
                        <div class="topright2s">
                            大数据
                        </div>
                        <div class="topright2s">
                            企业赋能
                        </div>
                        <div class="topright2s">
                            工业互联网
                        </div>
                        <div class="topright2s">
                            柔性产线
                        </div>
                    </div>
                    <div class="topright3">
                        <div class="topright3s">
                            <p>产品形态：</p>
                            <span>集成产品</span>
                        </div>
                        <div class="topright3s">
                            <p>付费模式：</p>
                            <span style="color:#FBA962;">按租期</span>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="center">

                <div style="width: 620px">
                    <el-form-item label="买方公司:" prop="company">
                        <el-input v-model="ruleForm.company"></el-input>
                    </el-form-item>
                    <div style="display: flex;justify-content: space-between">
                        <div style="width: 300px">
                            <el-form-item label="联系人:" prop="name">
                                <el-input v-model="ruleForm.name"></el-input>
                            </el-form-item>
                        </div>

                        <div style="width: 300px">
                            <el-form-item label="联系电话:" prop="phone">
                                <el-input v-model="ruleForm.phone"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div style="display: flex;justify-content: flex-start">
                        <el-form-item label="购买时长:">
                            <el-button type="primary">12个月</el-button>
                        </el-form-item>
                    </div>
                </div>



                <div v-for="(item,index) in alldata" :index="index">
                    <div class="titles" >
                        <div class="font">
                            {{item.modular}}
                        </div>
                        <div class="fontright" v-show="item.model!=0">
                            <div class="frunit" >
                                <p>服务模块:</p>
                                <span>{{item.model}}元</span>
                            </div>
                            <div class="frunit">
                                <p>端口:</p>
                                <span>{{item.sport}}元</span>
                            </div>
                        </div>

                    </div>
                    <div class="children" >
                        <div >
                            <el-form-item label="服务模块:" >
                                <div style="display: flex;">
                                    <div class="model "  :class="[its.focus==true ?'modelfocus':'']"  
                                         v-for="(its,inds) in item.children" :index="inds" 
                                         @click="countser(index,inds)">
                                        <p>{{its.modular}}</p>
                                        <span>{{its.price}}元/年</span>
                                    </div>
                                </div>

                            </el-form-item>
                            <el-form-item label="端口数:"  style="position: relative">
                                <span class="fivepay1">*</span>
                                <span class="fivepay" v-show="index>0">5个起售</span>
                                <div style="display: flex;justify-content: flex-start;align-items: center">
                                    <el-input-number
                                            v-model="item.sportnum"  @change="handleChange(index)" :min="item.sportnumlower"  label="描述文字"></el-input-number>
                                    <el-popover
                                            placement="top-start"
                                            width="200"
                                            trigger="hover"
                                            content="5个端口起售。每增加1个端口，增加300元/月。">
                                        <i slot="reference" class="el-icon-info" style="font-size: 24px;color:#fba962;margin-left: 0.2rem"></i>
                                    </el-popover>


                                </div>
                            </el-form-item>
                        </div>


                    </div>
                </div>





        </div>
        <div class="bottom">
            <div class="bots">
                <div class="bottom1">
                    <div class="bot1unit">
                        <p>服务模块费用合计：</p>
                        <span>￥{{modelall}}</span>
                    </div>
                    <div class="bot1unit">
                        <p>端口费用合计：</p>
                        <span>￥{{sportall}}</span>
                    </div>
                    <div class="bot1unit" style="font-size: 0.2rem;">
                        <p>总计：</p>
                        <span>￥{{all}}</span>
                    </div>
                </div>
                <div class="bottom2">
                    <el-button class="buttonclas" v-preventClick  @click="submitForm('ruleForm')">申请购买</el-button>
                </div>
            </div>

        </div>
        </el-form>
    </div>

</template>

<script>
    import {auth, anth} from '../request/api';

    export default {
        name: "editionpay",
        data() {
            return {
                ruleForm: {
                    company:"",
                    name:"",
                    phone:"",
                },
                rules:{
                    company: [
                        { required: true, message: '请输入公司名称', trigger: 'blur' },
                        { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
                    ],
                    name: [
                        { required: true, message: '请输入联系人', trigger: 'blur' },
                        { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: '请输入联系电话', trigger: 'blur' },
                        { min: 1, max: 15, message: '长度在 1 到 15 个字符', trigger: 'blur' },
                        {pattern:/^(((\d{3,4}-)?[0-9]{7,8})|(1(3|5|6|7|8|9)\d{9}))$/, message: '请输入正确的联系电话', trigger: 'blur'},
                    ],
                },
                /*普惠云服务模块*/
                alldata:[
                    {
                        name:"IDA普惠云",
                        model:0,//模块id
                        sport:0,
                        sportprice:3600,
                        sportnum:1, //模块端口数
                        sportnumlower:1,

                        children:[
                            {
                                id: 0, //服务模块内容id
                                name: '基础管理模块',//模块服务名称
                                price: 6000,//模块服务价格
                                focus:false,
                            }
                        ],

                    },
                    {
                        name:"IDA云运输",
                        model:0,
                        sport:0,
                        sportprice:3600,
                        children:[
                            {
                                id: 0,
                                name: '直运管理模块',
                                price: 48000,
                                focus:false,
                            },
                            {
                                id: 1,
                                name: '转运管理模块',
                                price: 18000,
                                focus:false,
                            },
                            {
                                id: 2,
                                name: '配载管理模块',
                                price: 18000,
                                focus:false,
                            },
                            {
                                id: 3,
                                name: '费用结算模块',
                                price: 12000,
                                focus:false,
                            },
                        ],
                        sportnumlower:5,
                        sportnum:5,
                    },
                    {
                        name:"IDA云包装",
                        model:0,
                        sport:0,
                        sportprice:3600,
                        children:[
                            {
                                id: 0,
                                name: '循环管理模块',
                                price: 60000,
                                focus:false,
                            },
                            {
                                id: 1,
                                name: '租赁管理模块',
                                price: 24000,
                                focus:false,
                            },
                            {
                                id: 2,
                                name: '包装盘点模块',
                                price: 18000,
                                focus:false,
                            },
                            {
                                id: 3,
                                name: '资产管理模块',
                                price: 12000,
                                focus:false,
                            },
                        ],
                        sportnumlower:5,
                        sportnum:5,
                    },
                    {
                        name:"IDA云仓储",
                        model:0,
                        sport:0,
                        sportprice:3600,
                        children:[
                            {
                                id: 0,
                                name: '出入库/库位管理模块',
                                price: 48000,
                                focus:false,
                            },

                            {
                                id: 1,
                                name: '库存盘点模块',
                                price: 12000,
                                focus:false,
                            },
                        ],
                        sportnumlower:5,
                        sportnum:5,
                    },

                ],

                modelall:0,
                sportall:0,
                all:0,

            }
        },
        created() {

        },
        mounted() {
            this.getmodular();
            this.count();
        },
        methods: {
            getmodular(){
                let url='/v1/website/offer/modular';
                auth(url).then(res=>{
                    if (res.data.code==1){
                        let arr=JSON.parse(JSON.stringify(res.data.data));
                        arr.forEach(v=>{
                            v.model=0;//声明模块费用，
                            v.sport=0;//声明端口费用
                            v.sportprice=3600;//声明端口价格
                            v.sportnumlower=Number(v.sportnumlower);
                            v.sportnum=Number(v.sportnum);
                            v.children.forEach(s=>{
                                s.sportnumlower=Number(s.sportnumlower);
                                s.sportnum=Number(s.sportnum)
                            })
                        })
                        this.alldata=arr;
                    } else{
                        this.$message({
                            type:'error',
                            message:res.data.msg
                        });
                    }
                })
            },
            countser(index,inds){
                // if(inds==0){
                //     this.alldata[index].children[inds].focus=!this.alldata[index].children[inds].focus;
                //     if(this.alldata[index].children[inds].focus==false){
                //         this.alldata[index].children.forEach(e=>{
                //             e.focus=false;
                //         })
                //     }
                // }else if(inds>0){
                    this.alldata[index].children[inds].focus=!this.alldata[index].children[inds].focus;
                    this.alldata[index].children[0].focus=true;
                // }
                this.count();
            },
            count(){
                this.modelall=0;
                this.sportall=0;
                this.all=0;
                this.alldata.forEach((e,i)=>{
                    let price=[];
                    e.children.forEach(v=>{
                        if(v.focus==true){
                            price.push(Number(v.price));
                        }
                        // if(i==0){
                        //     e.sportprice=0;
                        // }
                    });
                    // if(price.length!=0){
                        this.alldata[i].model=price.reduce((n,m) => n +m);//求和
                        this.alldata[i].sport=Number(this.alldata[i].sportnum) * Number(this.alldata[i].sportprice);
                    // }else{
                    //     this.alldata[i].model=0;//求和
                    //     this.alldata[i].sport=0;
                    // }
                    this.modelall+=Number(e.model);
                    this.sportall+=Number(e.sport);

                });
                this.all=Number(this.modelall)+Number(this.sportall);

            },
            handleChange(index){
                this.alldata[index].sport=Number(this.alldata[index].sportnum) * Number(this.alldata[index].sportprice);
                this.count();
            },
            submitForm(formName) {


                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if(this.all==0){
                            this.$message({
                                type:'warning',
                                message:'请选择服务模块!'
                            })
                        }else{
                            let arr=[];
                            this.alldata.forEach(v=>{
                                let obj={
                                    id:v.id,
                                    port:'',
                                    model:[],
                                };
                                v.children.forEach(s=>{
                                    if(s.focus==true){
                                        obj.model.push(s.id);
                                        obj.port=v.sportnum;
                                    }
                                });
                                arr.push(obj);
                            });
                            console.log(arr);

                            let url='/v1/website/offer/apply';
                            let data={
                                company_name:this.ruleForm.company,
                                tel_name:this.ruleForm.name,
                                phone:this.ruleForm.phone,
                                buy_time:'12个月',
                                //普惠云
                                // inclusive:arr[0].model.toString(),
                                // i_port:arr[0].port,
                                transport:arr[0].model.toString(),
                                t_port:arr[0].port,
                                packaging:arr[1].model.toString(),
                                p_port:arr[1].port,
                                warehouse:arr[2].model.toString(),
                                w_port:arr[2].port,
                                modular_cost:this.modelall,
                                port_cost:this.sportall,
                                all_cost:this.all,
                            };

                            auth(url,data).then(res=>{
                                if(res.data.code==1){
                                    this.$message({
                                        type:'success',
                                        message:'感谢您的购买，我们的销售人员会尽快联系您!'
                                    });
                                    this.$router.push('/edition')
                                }else{
                                    this.$message({
                                        type:'error',
                                        message:res.data.msg
                                    })
                                }
                            })

                        }
                    } else {
                        this.$message({
                            type:'warning',
                            message:'请完善您的信息!'
                        })
                        return false;
                    }
                });
            },
            jumpediton(){
                this.$router.push('/edition')
            },
        },
    }
</script>

<style scoped lang='scss'>
    .editionpaybox {
        width: 100%;
        height: 100vh;
        background: #F5F7FB;
        padding-bottom: 1rem;
        box-sizing: border-box;

        .top {
            width: 24rem;
            height: auto;
            background: #ffffff;
            position: fixed;
            top: 0;
            box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1);

            .topcontent {
                width: 18rem;
                margin: 0 auto;
                display: flex;
                align-items: center;
                height: 1.6rem;

                .topimg {
                    width: 1.5rem;
                    height: 1.5rem;
                    margin-right: 0.3rem;
                    cursor: pointer;

                    img {
                        width: 100%;
                    }
                }

                .topright {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: space-around;

                    .topright1 {
                        font-family: "PingFang SC";
                        font-size: 0.35rem;
                        margin-bottom: 0.05rem;
                    }

                    .topright2 {
                        display: flex;

                        .topright2s {
                            width: auto;
                            padding: 0 5px;
                            height: 18px;
                            line-height: 18px;
                            font-size: 14px;
                            color: #8AC7F8;
                            border: 1px solid #8AC7F8;
                            opacity: 1;
                            border-radius: 100px;
                            margin-right: 0.1rem;
                        }
                    }

                    .topright3 {
                        font-family: "PingFang SC";

                        display: flex;
                        margin: 0.1rem 0;

                        .topright3s {
                            width: 3rem;
                            display: flex;
                            font-size: 0.16rem;

                            p {
                                color: #999;
                            }

                            span {
                                color: #333;
                            }

                        }
                    }

                }
            }
        }

        .center {
            width: 18rem;
            position: fixed;
            top: 1.7rem;
            left: 0;
            right: 0;
            margin: auto;
            height: calc(100% - 2.4rem);
            /*height: 1500px;*/
            background: #ffffff;
            border-radius: 10px;
            padding: 15px;
            box-sizing: border-box;
            overflow-y: scroll;

            .titles {
                width: 100%;
                box-sizing: border-box;
                height: 0.4rem;
                background: #F5F7FB;
                border-radius: 4px;
                display: flex;
                justify-content: space-between;

                .font {
                    font-size: 0.2rem;
                    line-height: 0.4rem;
                    text-align: left;
                    padding: 0 0.1rem;
                    font-family: "PingFang SC";
                    color: #333;
                }

                .fontright {
                    display: flex;

                    .frunit {
                        margin-right: 0.2rem;
                        display: flex;
                        font-size: 0.2rem;
                        line-height: 0.4rem;
                        text-align: left;
                        padding: 0 0.1rem;
                        font-family: "PingFang SC";
                        color: #333;

                        p {
                            margin-right: 0.1rem;
                        }

                        span {
                            color: #FF9A26
                        }
                    }
                }
            }
            .children{
                padding-top: 0.5rem;
                .model{
                    width:3.5rem;
                    height: 0.5rem;
                    border: 1px solid #999999;
                    border-radius: 4px;
                    display: flex;
                    justify-content: space-between;
                    padding:0 0.2rem;
                    line-height: 0.5rem;
                    box-sizing: border-box;
                    font-family: "PingFang SC";
                    cursor: pointer;
                    overflow: hidden;
                    margin-right: 0.2rem;
                    margin-bottom: 0.2rem;
                    p{
                        font-size: 0.2rem;
                    }
                    span{
                        font-size: 0.16rem;
                        color:#999999
                    }
                }
                .modelfocus{
                    border: 1px solid #4781F5;
                    position: relative;
                    box-sizing: border-box;
                }
                .modelfocus:before{
                    position: absolute;
                    right: 1px;
                    bottom: 0;
                    content: "✓";
                    display: block;
                    line-height: 0.2rem;
                    z-index: 1;
                    color:#ffffff;

                }
                .modelfocus:after{
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    content: "√";
                    color:#fff;
                    display: block;
                    width: 0;
                    height: 0;
                    border-bottom: 0.3rem solid #4781F5;
                    border-left: 0.3rem solid transparent;
                }

                .fivepay{
                    position: absolute;
                    left: -100px;
                    top: 15px;
                    font-size: 0.1rem;
                    color:#999;
                }
                .fivepay1{
                    position: absolute;
                    left: -108px;
                    top: 0.05rem;
                    font-size: 0.2rem;
                    color:#F35959;
                }



            }
        }

        .bottom {
            width: 24rem;

            background: #fff;
            position: fixed;
            bottom: 0;
            box-shadow: 0px -3px 6px rgba(0, 0, 0, 0.09);

            .bots {
                width: 18rem;
                height:48px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .bottom1 {

                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 100%;

                    .bot1unit {
                        width: 5.25rem;
                        display: flex;
                        font-family: "PingFang SC";
                        font-size: 0.15rem;
                        line-height: 0.6rem;

                        p {
                            color: #333;
                        }

                        span {
                            color: #FF9A26;
                        }
                    }
                }

                .bottom2 {
                    width: 2rem;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;

                    .buttonclas {
                        height: 32px;
                        padding: 5px;
                        background: #FF9A26;
                        color: #ffffff;
                    }

                    .buttonclas:hover {
                        opacity: 0.8;
                    }

                    .buttonclas:active {
                        opacity: 0.5;
                        border: 1px solid #FBA962;
                    }

                }

            }
        }


    }
</style>
<style lang="scss">
    .editionpaybox{
        .el-form-item__label{
            font-family: "PingFang SC";
            /*font-size: 0.24rem;*/
            color: #333;
        }

        .el-input-number .el-input__inner{
            pointer-events: none!important;
        }
    }

</style>